import browserUpdate from 'browser-update/update.npm';

let browserFeatures = null;

export function getBrowserFeatures(required) {
    if (browserFeatures !== null) {
        return browserFeatures;
    }

    browserUpdate({
        required,
        insecure: true,
        unsupported: true,
        nomessage: true,
        test: true, // required to always trigger onshow callback
        onshow(infos) {
            browserFeatures = infos;
            browserFeatures.browser = global.$bu_getBrowser();
        },
    });

    return browserFeatures;
}
